import '../../styles/_rating.scss';

import React, { PropsWithChildren, useEffect, useState } from 'react';

import { Override } from '../../utility/types';

type Props = Override<React.ComponentPropsWithoutRef<'input'>, {
    name: string;
    ratings: Array<{ value: string | number, label: string }>;
    disabled?: boolean;
    value: string | number | null;
    onChange?: (value: string | number) => void;
    controlled?: boolean;
}, 'type' | 'title' | 'checked' | 'aria-label'>

export const Rating = React.forwardRef(({ name, ratings, value, onChange, disabled = false, children, controlled = false, ...props }: PropsWithChildren<Props>, ref: React.ForwardedRef<HTMLInputElement>) => {
    const [selected, setSelected] = useState(value ?? undefined);

    useEffect(() => {
        setSelected(value ?? undefined);
    }, [value]);

    return (
        <div className="rating-container" aria-live="polite" role="radiogroup" aria-disabled={disabled}>
            <div className="rating">
                {ratings.map((rating, i) => (
                    <label key={rating.value} className="rating-item">
                        <input ref={ref}
                            type="radio"
                            name={name}
                            value={rating.value}
                            title={rating.label}
                            disabled={disabled}
                            checked={selected === rating.value}
                            onChange={() => {
                                if (!controlled)
                                    setSelected(rating.value);
                                onChange?.(rating.value);
                            }}
                            aria-label={rating.label}
                            {...props}
                        />
                        <span className="rating-value" aria-hidden="true">{rating.value}</span>

                        {[0,ratings.length - 1].includes(i) && <span className="rating-label" aria-hidden="true">{rating.label}</span>}
                    </label>
                ))}
            </div>
            
            {children}
        </div>
    );
});

Rating.displayName = 'Rating';
